import {Flex} from "antd";
import {useState} from "react";
import {translations} from "./Translations";
import {getLangFromUrl} from "./Header";
import {ContactModal} from "./ContactModal";
import "./main.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faInstagram, faSquareFacebook,
} from "@fortawesome/free-brands-svg-icons";

export const Footer = () => {
    const lang = getLangFromUrl();
    const [contactOpen, setContactOpen] = useState(false);
    // @ts-ignore
    const t = translations[lang] || translations.en;

    return (
        <div className={"footer-wrapper"}>
            <Flex className={"footer"} align={'center'}>
                <Flex gap={10} className="footer-social" style={{flex: 1}}>
                    <a href="http://facebook.com/ugar.studio.games" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon className={"social-icon"} icon={faSquareFacebook} size={"2x"}/>
                    </a>
                    <a href="https://www.instagram.com/ugar.studio" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon className={"social-icon"} icon={faInstagram} size={"2x"}/>
                    </a>
                </Flex>
                <Flex vertical={true} align={'center'} gap={10}>
                    <img className={"footer-logo"} src={'/logo_black.svg'} style={{width: 100, height: 100}}/>
                    Ugar Studio Games. {new Date().getFullYear()}
                </Flex>
                <Flex gap={10} style={{flex: 1}} justify={'end'}>
                    <a onClick={() => setContactOpen(true)}>{t.contact}</a>
                </Flex>
            </Flex>
            <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} t={t} lang={lang}/>
        </div>
    )
}